import { ClientAndAdvisorTasks } from '../MeetingResults/CustomDisplay/ClientAndAdvisorTasks/ClientAndAdvisorTasks'
import { FutureMeetingsDisplay } from '../MeetingResults/CustomDisplay/FutureMeetings/FutureMeetingsDisplay'
import { FutureMeetingsHeaderButtons } from '../MeetingResults/CustomDisplay/FutureMeetings/FutureMeetingsHeaderButtons'
import { CustomPreset } from './models'
import { AddMeetingTaskToCRMModal } from '../../../../../views/MeetingSummary/CRM/V2/AddTaskToCRMModal'
import { FamilyTree } from '../MeetingResults/CustomDisplay/FamilyTree/FamilyTree'
import { ConversationTimeline, copyConversationTimeline } from '../MeetingResults/CustomDisplay/ConversationTimeline/ConversationTimeline'
import { FamilyTreeCollapsed } from '../MeetingResults/CustomDisplay/FamilyTree/FamilyTreeCollapsed'
import { ConversationTimelineCollapsed } from '../MeetingResults/CustomDisplay/ConversationTimeline/ConversationTimelineCollapsed'
import { ResultCardHeaderButtonsWithoutEdit } from '../MeetingResults/ResultCard/Header/ResultCardHeaderButtonsWithoutEdit'
import { EmailResultCardHeaderButtons } from '../MeetingResults/ResultCard/Header/EmailResultCardHeaderButtons'
import { AiFeature } from '../../../../../models/AiFeature'
import { AdvisorReferral } from '../MeetingResults/CustomDisplay/AdvisorReferral/AdvisorReferralView'
import { copyAdvisorReferral } from '../MeetingResults/CustomDisplay/AdvisorReferral/utils'
import { copyTasks } from '../MeetingResults/CustomDisplay/ClientAndAdvisorTasks/utils'
import { env } from '../../../../../common/util'
import {
  ADVISOR_REFERRAL_PRESET_IDS,
  CLIENT_AND_ADVISOR_FOLLOW_UPS_PRESET_IDS,
  CONVERSATION_TIMELINE_PRESET_IDS,
  FAMILY_TREE_PRESET_IDS,
  FOLLOW_UP_EMAIL_PRESET_IDS,
  FUTURE_MEETINGS_PRESET_IDS,
} from '../../../../../views/MeetingSummary/CRM/PresetMappings'

export const CUSTOM_PRESET_MAPPING: { [key: string]: CustomPreset } = {
  [CLIENT_AND_ADVISOR_FOLLOW_UPS_PRESET_IDS[env]]: {
    display: ClientAndAdvisorTasks,
    crmModal: AddMeetingTaskToCRMModal,
    headerButtons: ResultCardHeaderButtonsWithoutEdit,
    copyResult: copyTasks,
  },
  [FUTURE_MEETINGS_PRESET_IDS[env]]: {
    display: FutureMeetingsDisplay,
    headerButtons: FutureMeetingsHeaderButtons,
  },
  [CONVERSATION_TIMELINE_PRESET_IDS[env]]: {
    display: ConversationTimeline,
    collapsedDisplay: ConversationTimelineCollapsed,
    headerButtons: ResultCardHeaderButtonsWithoutEdit,
    copyResult: copyConversationTimeline,
  },
  [FAMILY_TREE_PRESET_IDS[env]]: {
    display: FamilyTree,
    collapsedDisplay: FamilyTreeCollapsed,
  },
  [FOLLOW_UP_EMAIL_PRESET_IDS[env]]: {
    headerButtons: EmailResultCardHeaderButtons,
  },
  [ADVISOR_REFERRAL_PRESET_IDS[env]]: {
    display: AdvisorReferral,
    headerButtons: ResultCardHeaderButtonsWithoutEdit,
    copyResult: copyAdvisorReferral,
  },
}

export const isAiFeatureClientAndAdvisorFollowUpTasks = (aiFeature: AiFeature) => {
  const { preset: { id: aiFeaturePresetId = '' } = {} } = aiFeature
  return aiFeaturePresetId === CLIENT_AND_ADVISOR_FOLLOW_UPS_PRESET_IDS[env]
}
